export function logNewRelic(message: string, data: any, level: 'info' | 'warn' | 'error' = 'error') {
  if (typeof window !== 'undefined' && 'newrelic' in window) {
    (window.newrelic as any).log(message, {
      level,
      customAttributes: data,
    })
  }
}

export function setNewRelicUserId(userId: string | number | undefined | null) {
  if (typeof window !== 'undefined' && 'newrelic' in window) {
    try {
      // Set userId to null to clear it on logout, or to the string value when logging in
      (window.newrelic as any).setUserId(userId ? String(userId) : null)
    } catch(error) {
      // Silently fail if setUserId is not available or errors
      console.warn('Failed to set NewRelic user ID:', error)
    }
  }
}
